export default "__VITE_ASSET__ydUSThhk__"